import { useEffect, useState } from "react";
import { useServiceWorkerUpdater } from "../hooks/useServiceWorkerUpdater";

export default function UpdateToast() {
    const { isUpdateAvailable, updateApp } = useServiceWorkerUpdater();
    const [visible, setVisible] = useState(false);
    const [isFadingOut, setIsFadingOut] = useState(false);

    useEffect(() => {
        if (isUpdateAvailable) {
            setVisible(true);

            // Auto-hide after 10s
            const timer = setTimeout(() => handleClose(), 10000);
            return () => clearTimeout(timer);
        }
    }, [isUpdateAvailable]);

    const handleClose = () => {
        setIsFadingOut(true);
        setTimeout(() => setVisible(false), 3000); // match fade-out duration
    };

    if (!visible) return null;

    return (
        <div
            className={`fixed bottom-4 left-1/2 -translate-x-1/2 bg-indigo-600 text-white px-6 py-3 rounded-xl shadow-lg flex items-center gap-3 z-50 
        ${isFadingOut ? "animate-fade-out" : "animate-fade-in"}`}
        >
            <span>⚡ New version available!</span>
            <button
                onClick={updateApp}
                className="ml-2 bg-white text-indigo-600 font-medium px-3 py-1 rounded-lg hover:bg-gray-100"
            >
                Refresh
            </button>
            <button
                onClick={handleClose}
                className="ml-2 text-white hover:text-gray-200 font-bold"
                aria-label="Dismiss"
            >
                ✕
            </button>
        </div>
    );
}
